import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/pro-solid-svg-icons'

import BaseButton from 'components/Button'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import replaceTextShortCodes from 'functions/replaceTextShortCodes'
import { digObject } from 'functions/utilities'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'

const buttonIcon = {
  menu: faBars,
}

const toggleGallery = (context, props) => {
  const { callbacks: { toggleGallery: toggleGalleryFn }, index } = context
  const { options } = props
  const { galleryKey } = options || {}

  if (toggleGalleryFn && galleryKey){
    const indexValue = index || 0
    toggleGalleryFn(galleryKey, indexValue)
  }
}

const updateDataStore = (props) => {
  const {
    callbacks: { updateDataStore: updateDataStoreFn },
    options,
  } = props

  const {
    inputDataStoreBehaviour, inputDataStoreKey, inputDataStoreValue,
  } = options || {}

  const payload = {
    key: inputDataStoreKey,
    label: inputDataStoreValue,
    behaviour: inputDataStoreBehaviour || 'replace',
    value: inputDataStoreValue,
    data: {
      hidden: true,
    },
  }

  updateDataStoreFn(payload)
}

const processMultiple = (context, callbacks, props) => {
  const { options } = props
  const { triggers } = options || {}

  if (triggers){
    triggers.forEach(({ value }) => {
      // eslint-disable-next-line no-use-before-define
      const triggerFn = triggerFunction(value, context, callbacks, props)
      if (triggerFn) triggerFn()
    })
  }
}

const regroupFormResponse = (props) => {
  const { callbacks: { regroupFormResponse: regroupFormResponseFn } } = props
  const tag = digObject(props, 'options.formDataStoreTag', '')

  regroupFormResponseFn(tag)
}

const submitFormResponse = (props) => {
  const { callbacks: { submitFormResponse: submitFormResponseFn } } = props
  const tag = digObject(props, 'options.formDataStoreTag', '')

  submitFormResponseFn(tag)
}

const triggerFunction = (trigger, context, callbacks, props) => {
  if (trigger === 'multiple') return () => processMultiple(context, callbacks, props)
  if (trigger === 'updateDataStore') return () => updateDataStore(props)
  if (trigger === 'toggleGallery') return () => toggleGallery(context, props)
  if (trigger === 'regroupFormResponse') return () => regroupFormResponse(props)
  if (trigger === 'submitFormResponse') return () => submitFormResponse(props)
  return callbacks[trigger]
}

const Button = (props) => {
  const { callbacks, context: componentContext, options } = props

  const {
    href, icon, text: textString, trigger, ...buttonOptions
  } = options || {}

  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const contextData = { ...defaultContext, ...componentContext }

  const link = replaceTextShortCodes(href, contextData)
  const text = replaceTextShortCodes(textString, contextData)

  const onClick = triggerFunction(trigger, contextData, callbacks, props)

  return (
    <AnimationWrapper options={options}>
      <BaseButton
        icon={buttonIcon[icon] ? <FontAwesomeIcon icon={buttonIcon[icon]} /> : null}
        href={onClick ? null : link}
        onClick={onClick}
        style={style}
        text={text}
        {...buttonOptions}
      />
    </AnimationWrapper>
  )
}

Button.propTypes = {
  callbacks: PropTypes.object,
  context: PropTypes.object,
  data: PropTypes.object,
  options: PropTypes.object,
  style: PropTypes.object,
}

Button.defaultProps = {
  data: {},
  options: {},
}

export default Button
